import dynamic from 'next/dynamic';
import type { FC } from 'react';
import { RenderComponents } from '@/Module/Core/Component';
import { relatedLessonSectionSelectIds } from '@/Module/Lesson/Store/Selector';
import { useAppSelector } from '@/Module/Store/Hook';
const DesktopComponent = dynamic(() => import('./Desktop/LessonRelatedDesktop'));
const MobileComponent = dynamic(() => import('./Mobile/LessonRelatedMobile'));
const LessonRelated: FC = () => {
  const ids = useAppSelector(relatedLessonSectionSelectIds);

  // TODO implement empty list
  if (!ids.length) return null;
  return <>
      <div className="mb-1 font-bold text-orangeFive lg:text-lg">ویدیو های مرتبط</div>
      <div className="mb-4 text-blackFive">دیگر قسمت های درس درحال مشاهده</div>
      <RenderComponents DesktopComponent={DesktopComponent} MobileComponent={MobileComponent} ids={ids} data-sentry-element="RenderComponents" data-sentry-source-file="LessonRelated.tsx" />
    </>;
};
export default LessonRelated;